export const mobileMaxWidth = window.matchMedia("(max-width: 991px)");
export const desktopMinWidth = window.matchMedia("(min-width: 800px)");



// WEBPACK FOOTER //
// ./javascript/_common/breakPoints.js